<template>
  <!-- <h1 style="text-align:center">Page Not Found</h1> -->


  <v-container class="pt-3">

    <v-layout justify-center class="mt-4">
      <img width="400" height="400" src="../../../static/sad.png" style="opacity:0.6" alt="">
    </v-layout>

    <v-layout justify-center row>
      <h3 style="opacity:0.6">Page not found</h3>
    </v-layout>

    <v-layout justify-center row>
      <p style="opacity:0.7">The page you are looking for does not exist or an error had occured.</p>
    </v-layout>

  </v-container>
</template>

<script>
export default {
  
}
</script>



// WEBPACK FOOTER //
// src/components/Common/NotFound.vue